import { render, staticRenderFns } from "./AddStartupsCustomField.vue?vue&type=template&id=4a3e0c9e&scoped=true&"
import script from "./AddStartupsCustomField.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddStartupsCustomField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddStartupsCustomField.vue?vue&type=style&index=0&id=4a3e0c9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3e0c9e",
  null
  
)

export default component.exports